import store from 'store2'

import post from '../../../lib/post'

export default function(roll,start,deleteStart){

  var ombStore = store.namespace('omb')

  post(
    'data',
    {
      token: ombStore('token'),
      type: 'thumb',
      roll: roll,
      start: start,
      deleteStart: deleteStart,
    },
    function(){
      console.log('thumb generated',roll,start)
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/generateThumb.js